import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../../Config/AxiosInstance";
import APILIST from "../../../Config/ApiList";
export const GET_USERS_INTERPRETOR = createAsyncThunk('/users-interpretor/get', async (params) => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_USERS_INTERPRETER, {
      params: {
        skip: params?.page * params?.pageSize,
        limit: params?.pageSize,
        ...(params?.debouncedSearch && { search: params?.debouncedSearch }),
        ...(params?.isRole && { is_interpreter: params?.isRole === 1 ? 0 : 1 }),
        ...(params?.activeTab && params?.activeTab !== 0 && { is_interpreter: 1, interpreter_verified: params?.activeTab === 1 ? 0 : -1 })
      }

    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const GET_MILISTONE_USER_INTERPRETER_ACTION = createAsyncThunk('/user-interpreto/get_milistone', async (id) => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_MILISTONE_USERS_INTERPRETOR, {
      params: {
        interpreter_id: id
      }
    });
    console.log('response', response);

    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const GET_PLAN_USER_INTERPRETER_ACTION = createAsyncThunk('/user-interpreto/get_plan', async (id) => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_PLAN_USERS_INTERPRETOR, {
      params: {
        user_id: id
      }
    });
    console.log('response', response);

    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const GET_BY_ID_USER_INTERPRETER_ACTION = createAsyncThunk('/user-interpreto/get_by_id', async (id) => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_BY_ID_USERS_INTERPRETOR, {
      params: {
        user_id: id
      }
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const USER_INTERPRETO_ACCOUNT_ACTION = createAsyncThunk('/interpreto/account_status', async ({ userId, formData1 }) => {
  try {
    const url = `${APILIST.INTERPRETER_STATUS_UPDATED}/${userId}`;
    const response = await AxiosInstance.post(url, formData1);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const USER_ACCOUNT_STATUS_ACTION = createAsyncThunk('/users/account_status', async ({ userId, status }) => {
  try {
    const params = {
      user_id: userId,
      status: status
    }
    const response = await AxiosInstance.post(APILIST.USER_ACCOUNT_STATUS, params);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})
export const USER_RATE_AND_REVIEW_ACTION = createAsyncThunk('/users/rate-and-review', async (userId) => {
  console.log('userId', userId);

  try {
    const response = await AxiosInstance.get(APILIST.GET_RATE_AND_REVIEW, {
      params: {
        user_id: userId,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})
// =========== INTREPRETER_PROFILE_APPROVE =================
export const USER_INTERPRETER_LANGUAGE_COMMISION_FIRST_ACTION = createAsyncThunk('POST/USER_INTERPRETER_LANGUAGE_COMMISION_FIRST', async (formData) => {
  try {
    const response = await AxiosInstance.post(APILIST.INTERPRETER_USER_ADMIN_LANGUAGE_COMMISSION, formData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const USER_INTERPRETO_ACCOUNT_APPROVE_FIRST = createAsyncThunk('/POST/USER_INTERPRETER_ACCOUNT_APPROVE_FIRST', async ({ userId, status, userLanguageList }) => {
  try {
    const formdata = new FormData();
    // if (userLanguageList[0]?.certificates) {
    //   formdata.append("is_certified", 1);
    // }
    formdata.append('interpreter_verified', status);
    const url = `${APILIST.INTERPRETER_STATUS_UPDATED}/${userId}`;
    const response = await AxiosInstance.post(url, formdata);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const USER_INTERPRETO_ACCOUNT_REJECT_FIRST = createAsyncThunk('/POST/USER_INTERPRETER_ACCOUNT_REJECT_FIRST', async ({ userId, formData }) => {
  try {
    const url = `${APILIST.INTERPRETER_STATUS_UPDATED}/${userId}`;
    const response = await AxiosInstance.post(url, formData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const USER_INTERPRETER_LANGUAGE_COMMISION_ACTION = createAsyncThunk('POST/USER_INTERPRETER_LANGUAGE_COMMISION', async (formData) => {
  try {
    const response = await AxiosInstance.post(APILIST.INTERPRETER_USER_ADMIN_LANGUAGE_COMMISSION, formData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const USER_INTERPRETO_ACCOUNT_APPROVE = createAsyncThunk('/POST/USER_INTERPRETER_ACCOUNT_APPROVE', async ({ userId, status }) => {
  try {
    const formdata = new FormData();
    formdata.append('interpreter_verified', status);
    const url = `${APILIST.INTERPRETER_STATUS_UPDATED}/${userId}`;
    const response = await AxiosInstance.post(url, formdata);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const USER_INTERPRETO_ACCOUNT_REJECT = createAsyncThunk('/POST/USER_INTERPRETER_ACCOUNT_REJECT', async ({ userId, formData }) => {
  try {
    const url = `${APILIST.INTERPRETER_STATUS_UPDATED}/${userId}`;
    const response = await AxiosInstance.post(url, formData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});



